// document.addEventListener("DOMContentLoaded", (event) => {
//    Fancybox.bind(document.getElementById("customjef_mediaProduct"), "[data-fancybox]", {
//    // Fancybox.bind('[data-fancybox="imageJef"]', {
//       //   Carousel: {
//       //     Navigation: true,
//       //     // transition: "slide",
//       //   },
//       //   // Images: {
//       //   //   zoom: false,
//       //   // },
//       //   Toolbar: {
//       //     display: {
//       //       left: [
//       //         //"infobar",
//       //       ],
//       //       middle: [
//       //         //"prev", "infobar", "next"
//       //       ],
//       //       right: [
//       //         // "slideshow",
//       //         //"download",
//       //         //"thumbs",
//       //         "fullscreen",
//       //         "close",
//       //       ],
//       //     }
//       //   }

//       Hash: false,
//       Thumbs: false,
      
//       // compact: false,
//       // contentClick: "toggleCover",
//       // // wheel : "slide",
      
//       Toolbar: {
//         display: {
//           left: [],
//           middle: [],
//           right: ["fullscreen", "close"],
//         },
//       },
      
//       // Images: {
//       //   Panzoom: {
//       //     panMode: "mousemove",
//       //     mouseMoveFactor: 1.1,
//       //     mouseMoveFriction: 0.12
//       //   },
//       // },

       
//     })
// });

const originalFetchJef = window.fetch;
window.fetch = function() {
  const fetchPromise = originalFetchJef.apply(this, arguments);
  // Controlla l'URL per verificare se è una richiesta add to cart
  if (arguments[0].includes('/cart/add')) {
    // Esegui azioni al momento dell'invio della richiesta
    // console.log("Invio della richiesta di aggiunta al carrello...");

    // Mostra un indicatore di caricamento
    document.getElementById('customjef_addtocartproduct').style.backgroundColor = '#bdbbbb';
    
    fetchPromise.then(response => {
      // Esegui azioni al completamento della richiesta
      // console.log("Richiesta completata!");
      // Nascondi l'indicatore di caricamento
      document.getElementById('customjef_addtocartproduct').style.backgroundColor = '#c1dbf3';

      return response;
    }).catch(error => {
      // Gestisci gli errori della richiesta
      // console.log("Errore nella richiesta di aggiunta al carrello:", error);
      
      // Nascondi l'indicatore di caricamento
      document.getElementById('customjef_addtocartproduct').style.backgroundColor = 'red';
    });
  }
  return fetchPromise;
};


(function($) {
  function customjef_changeDisplayTitleProduct(document)
  {
    const scrollPosition =  document.scrollTop();
    const buttonAddtoCart = $('.product-buy-buttons--cta')
    if( buttonAddtoCart.length === 0 ) return;
    const titleProduct = $('.customjef_heading_collection.productTitle')
    if( titleProduct.length === 0 ) return;
    const formAddtoCartOffset = $(buttonAddtoCart).offset().top
    // console.log("scrollPosition")
    // console.log(scrollPosition)
    // console.log("formAddtoCartOffset")
    // console.log(formAddtoCartOffset)
    
    if(scrollPosition > formAddtoCartOffset )
    {
      titleProduct.addClass('hiddenTitle')
    }
      else
    {
      titleProduct.removeClass('hiddenTitle')
    }
  }
  function customjef_changeSubMenuDesktop()
  {
    const xMenuLevel2Container = $('.header--root .header--top-row .x-menu--level-2--container')
    if(xMenuLevel2Container.length === 0 ) return;
    xMenuLevel2Container.each(function()
    {
      const li_a = $(this).closest('li').find('> a')
      const _this = $(this)
      _this.appendTo("#newSubMenu")
      
      li_a.on('mouseover',function()
      {
        xMenuLevel2Container.removeClass('openedNew')
        _this.addClass('openedNew')
        $('.customjef_heading_collection').hide()
      })  
      
      // li_a.on('mouseleave',function()
      // {
      //   xMenuLevel2Container.removeClass('openedNew')
      // })  

      _this.on('mouseleave',function()
      {
        xMenuLevel2Container.removeClass('openedNew')
        $('.customjef_heading_collection').show()
      })

      $(document).mouseleave(function () {
          xMenuLevel2Container.removeClass('openedNew')
          $('.customjef_heading_collection').show()
      }) 
    })
    const mainLinkNoSubMenu = $('.header--root .header--top-row .x-menu--level-1--container li.x-menu--level-1--link')
    mainLinkNoSubMenu.each(function()
   {
     const depthLink = $(this).attr('data-x-menu--depth')
     // console.log(depthLink)
     if(depthLink == 1)
     {
        $(this).on('mouseover',function()
        {
          xMenuLevel2Container.removeClass('openedNew')
          $('.customjef_heading_collection').show()
        })
     }
   })
    const logoWeb = $('#logoWeb')
    logoWeb.on('mouseover',function()
    {
      xMenuLevel2Container.removeClass('openedNew')
      $('.customjef_heading_collection').show()
    })
  }

  function customjef_newPositionHeaderAnnoucement()
  {
    const announcementBanner = $('.announcement--root .announcement--wrapper')
    // console.log(announcementBanner)
    if(announcementBanner.length === 0) return;
    $('body').addClass('has_annoucement')
    const header = $('.section--header .header--root')
    // console.log(header)
    const announcementBannerHeight = announcementBanner.outerHeight()

    const windowOffset = $(window).scrollTop()
    const ulSubMenu = $('#newSubMenu .x-menu--level-2--container ul')

    // const form_product_page_form = $('form.product-page--form')
     
    if(windowOffset < announcementBannerHeight)
    {
      header.attr('style', 'top: '+(announcementBannerHeight - windowOffset)+'px !important');
      ulSubMenu.attr('style', 'padding-top: '+(announcementBannerHeight - windowOffset)+'px');
      // if(form_product_page_form.length > 0 )
      // {
      //   form_product_page_form.addClass('addHeight')
      // }
    }
    
  }

  function customjef_newPositionHeaderAnnoucement_Scroll(document)
  {
    const announcementBanner = $('.announcement--root .announcement--wrapper')
    if( announcementBanner.length === 0 ) return;
    // let faccio = true
    const scrollPosition =  document.scrollTop();
    const header = $('.section--header .header--root')
    const announcementBannerOffset = announcementBanner.offset().top
     const announcementBannerHeight = announcementBanner.outerHeight()
    // console.log("scrollPosition")
    // console.log(scrollPosition)
    // console.log("announcementBannerOffset")
    // console.log(announcementBannerOffset)

    // console.log("announcementBannerHeight")
    // console.log(announcementBannerHeight)

    const ulSubMenu = $('#newSubMenu .x-menu--level-2--container ul')
    const form_product_page_form = $('#rightProduct') //$('form.product-page--form')
    if(scrollPosition > announcementBannerHeight )
    {
      // header.css({'translateY':'-100%'})
      header.attr('style', 'top: 0px !important');
      ulSubMenu.attr('style', 'padding-top: 0px');
      if(form_product_page_form.length > 0 )
      {
         form_product_page_form.addClass('addHeight')
      }
    }
      else
    {
      // header.css({'translateY': '-'+scrollPosition +'px'})
      header.attr('style', 'top:  '+(announcementBannerHeight - scrollPosition)+'px !important');
      ulSubMenu.attr('style', 'padding-top: '+(announcementBannerHeight - scrollPosition)+'px');
      if(form_product_page_form.length > 0 )
      {
         form_product_page_form.removeClass('addHeight')
      }
    }
  }

  function customjef_displaySizeGuideImage()
  {
    const sizeguide_button = $('.sizeguide_button')
    if(sizeguide_button.length == 0) return;

    const overlay_sizeguide_image = $('#overlay_sizeguide_image')
    if(overlay_sizeguide_image.length == 0) return;
    const overlay_sizeguide_bg = $('.overlay_jef_bg')

    
    sizeguide_button.each(function()
    {
      const _that = $(this)
      _that.on('click',function()
      {
        overlay_sizeguide_image.addClass('active')
        overlay_sizeguide_bg.addClass('active')
        $('body').css({'overflow-y':'hidden'})
      })
    })
    const closeBox = $('#closeBox')
    if(closeBox.length == 0) return;
    closeBox.on('click',function()
    {
      overlay_sizeguide_image.removeClass('active')
      overlay_sizeguide_bg.removeClass('active')
      $('body').css({'overflow-y':'auto'})
    })
  }
  
  function mainTabsProduct()
  {
    const mainTabsProduct = $('.template--product').find('#mainTabsProduct')
    if(mainTabsProduct.length === 0 ) return;
    mainTabsProduct.tabs(); 
  }

  $(window).on('load', function() 
  {	
     
    $('#customjef_mediaProduct .fancybox[data-fancybox="gallery"]').fancybox({
          buttons: [
              // "zoom",
              //"share",
              //"slideShow",
              "fullScreen",
              //"download",
              //"thumbs",
              "close"
          ],
      
      });
  })

  

  $(document).ready(function() 
  {	
    customjef_changeSubMenuDesktop() 
    customjef_newPositionHeaderAnnoucement()
    // customjef_changeSubMenuDesktopOpen()
    customjef_displaySizeGuideImage()
    mainTabsProduct()
  })
  $(document).on('scroll',function()
  {
    customjef_changeDisplayTitleProduct($(this))
    customjef_newPositionHeaderAnnoucement_Scroll($(this))
  })

})(jQuery);